/*
	ai_foe.ts
  Copyright (c) 2013-present Human Cube Inc.
  Friend and Foe count and distance calculations.
*/

import bfH from '../bfcore/bf_helper';
import { Game } from '../bfcore/gameTypes';
import { WorkingData } from '../bfworking/workingTypes';


export function calcFriendFoeCounts (working: WorkingData, game: Game): {
  friend: number[], foe: number[],
} {
  // Returns two arrays of the count of friendly and enemy forces for all zones.
  const friend = new Array(game.zones + 1).fill(0);
  const foe = new Array(game.zones + 1).fill(0);

  const playerIndex = working.localPlayerIndex;
  const forcesCount = working.force.length;
  const forces = working.force;

  let factoryTypeIndex = bfH.getForceTypeIndexByName(game, 'Factory');

  for (let j = 0; j < forcesCount; j++) {
    let force = forces[j];
    if(force.ft === factoryTypeIndex) {
      continue;  // Do not count factories.
    }
    const zoneID = force.z;
    if (zoneID <= 0 || zoneID > game.zones) {
      continue;
    }
    // TODO: handle teammates here...
    if (force.owner === playerIndex) {
      friend[zoneID]++;
    }
    else {
      foe[zoneID]++;
    }
  }
  return { friend, foe };
}

export function calcFoeDistances (game: Game, foe: number[]): {
  foeDistanceAir: number[], foeDistanceLand: number[],
} {
  // foe array is count of enemy forces for each zone.
  // Returns distances to enemy forces either by land only or by water and land.

  const zoneCount = game.zones;
  const foeDistanceAir = new Array(zoneCount + 1).fill(255);
  const foeDistanceLand = new Array(zoneCount + 1).fill(255);

  for (let zoneID = 1; zoneID <= zoneCount; zoneID++) {
    if (foe[zoneID]) {
      foeDistanceAir[zoneID] = 0;
      foeDistanceLand[zoneID] = 0;
    }
  }

  for (let distance = 0; distance < 100; distance++) {
    let didSomething = false;
    for (let zoneID = 1; zoneID <= zoneCount; zoneID++) {
      if (foeDistanceAir[zoneID] === distance) {
        for (let i = 0; i < game.bordersLand[zoneID].length; i++) {
          const tryZoneID = game.bordersLand[zoneID][i];
          if (foeDistanceAir[tryZoneID] > distance + 1) {
            foeDistanceAir[tryZoneID] = distance + 1;
            didSomething = true;
          }
        }
        for (let i = 0; i < game.bordersWater[zoneID].length; i++) {
          const tryZoneID = game.bordersWater[zoneID][i];
          if (foeDistanceAir[tryZoneID] > distance + 1) {
            foeDistanceAir[tryZoneID] = distance + 1;
            didSomething = true;
          }
        }
      }
      if (foeDistanceLand[zoneID] === distance) {
        for (let i = 0; i < game.bordersLand[zoneID].length; i++) {
          const tryZoneID = game.bordersLand[zoneID][i];
          if (foeDistanceLand[tryZoneID] > distance + 1) {
            foeDistanceLand[tryZoneID] = distance + 1;
            didSomething = true;
          }
        }
      }
    }
    if(!didSomething) {
      break;  // all done.
    }
  }

  return { foeDistanceAir, foeDistanceLand };
}
